/* eslint-disable import/named */
import React from 'react';

import { ThemeProvider } from 'styled-components';
import Routes from './routes';
import { GlobalStyle, Theme } from '~/styles';

import MainContextProvider from '~/context';

const App = () => {
  return (
    <MainContextProvider>
      <ThemeProvider theme={Theme}>
        <Routes />
        <GlobalStyle />
      </ThemeProvider>
    </MainContextProvider>
  );
};

export default App;
